// extracted by mini-css-extract-plugin
export default {"cls1":"hfjSJ8c2PnOPCUerHZTQ","cls2":"bxvkf3eAxjgt50pz4j3F hfjSJ8c2PnOPCUerHZTQ","isPhone":"RNZJTiI3sXbMakhxKfvN"};